import { ChangeEvent } from 'react';
import { SelectProps } from '@mui/material';

export const titleLabelFormatter = <T extends { title: string }>(item: T) => item.title;

export const valueLabelFormatter = <T extends { value: string }>(item: T) => item.value;

export const slugValueFormatter = <T extends { slug: string }>(item: T) => item.slug;

export const idValueFormatter = <T extends { id: number | string }>(item: T) => String(item.id);

export const stringValueFormatter = <T>(item: T) => String(item);

export const nameValueTransformer = ({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => ({ [name]: value });

export const nameValueParser = (queryParams: Record<string, string | string[]>, name: string) => queryParams[name];

export const clearValueParser: (
  queryParams: Record<string, string | string[]>,
  name: string,
) => { [key: string]: undefined } = (queryParams, name) => ({
  [name]: undefined,
});

export const getValue = (value: string | string[], { multiple }: SelectProps): string | string[] => {
  if (!value) return multiple ? [] : '';
  if (multiple && !Array.isArray(value)) return [value];
  return value;
};

export const filterValue = (value: string | string[], availableValues: Set<string>) => {
  if (Array.isArray(value)) return value.filter((v) => availableValues.has(v));
  if (availableValues.has(value)) return value;
  return '';
};
